import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Image, ImageSourcePropType, Text, TouchableOpacity} from 'react-native';
import styleSheet from './styles';

export interface ProfileButtonProps {
  text: string;
  image: ImageSourcePropType;
  colorText?: string;
  onPress: () => void;
}

const ProfileButton = (props: ProfileButtonProps) => {
  const styles = styleSheet(useTheme());

  return (
    <TouchableOpacity style={styles.container} onPress={props.onPress}>
      <Image style={styles.image} source={props.image} />
      <Text
        style={[styles.text, props.colorText ? {color: props.colorText} : {}]}>
        {props.text}
      </Text>
    </TouchableOpacity>
  );
};

export default ProfileButton;
